import { render, staticRenderFns } from "./WorkspaceLibraryModal.vue?vue&type=template&id=4287b124&scoped=true"
import script from "./WorkspaceLibraryModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceLibraryModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLibraryModal.vue?vue&type=style&index=0&id=4287b124&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287b124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4287b124')) {
      api.createRecord('4287b124', component.options)
    } else {
      api.reload('4287b124', component.options)
    }
    module.hot.accept("./WorkspaceLibraryModal.vue?vue&type=template&id=4287b124&scoped=true", function () {
      api.rerender('4287b124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceLibraryModal.vue"
export default component.exports